// extracted by mini-css-extract-plugin
export var collapsedSummary = "_sf-0";